import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react'
import { cn } from '@bem-react/classname'
import { Memo } from '@/hoc/Memo'

import './Title.scss'

const cnTitle = cn('Title')

export interface TitleSchema
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: ReactNode
}

export const Title: FC<TitleSchema> = Memo(
  ({ className, children }: TitleSchema) => {
    return <div className={cnTitle(null, [className])}>{children}</div>
  },
)
